import { __assign } from '../../node_modules/tslib/tslib.es6.js';
import { jsx } from 'react/jsx-runtime';
import { Menu } from '@cheetahdigital/console-kit-cx';
import classNames from '../../node_modules/classnames/index.js';
import { forwardRef } from 'react';
import { useTranslation } from '../../locales/i18n.js';
import 'semantic-ui-react';
import Dropdown from '../../shared/components/Dropdown/index.js';
import 'react-dom';
import NavbarLink from '../NavbarLink/index.js';
import styles from './index.module.scss.js';

var NavbarMore = forwardRef(function (_a, ref) {
    var label = _a.label, icon = _a.icon, isHidden = _a.isHidden, children = _a.children;
    var t = useTranslation()[0];
    return (jsx("div", __assign({ className: classNames("navbarMore", styles.navbarMore, isHidden && styles.isHidden), ref: ref }, { children: jsx(Menu.Submenu, { children: jsx(Dropdown, __assign({ isAutoWidth: true, position: "bottom right", trigger: jsx(NavbarLink, __assign({ className: "navbarMoreTrigger", icon: icon || "down" }, { children: jsx("span", { children: label !== undefined ? label : t("more") }, void 0) }), void 0) }, { children: jsx("div", __assign({ className: classNames("navbarMoreDropdown", styles.navbarMoreDropdown) }, { children: children }), void 0) }), void 0) }, void 0) }), void 0));
});
NavbarMore.displayName = "NavbarMore";

export { NavbarMore as default };
